__turbopack_context__.v({
  "auth-redirect-footer": "paywall-module-scss-module__FpKhna__auth-redirect-footer",
  "check-icon": "paywall-module-scss-module__FpKhna__check-icon",
  "content-wrapper": "paywall-module-scss-module__FpKhna__content-wrapper",
  "desktop-animal": "paywall-module-scss-module__FpKhna__desktop-animal",
  "optimizely-reg-paywall": "paywall-module-scss-module__FpKhna__optimizely-reg-paywall",
  "paywall-auth-buttons": "paywall-module-scss-module__FpKhna__paywall-auth-buttons",
  "paywall-button": "paywall-module-scss-module__FpKhna__paywall-button",
  "paywall-check-icon": "paywall-module-scss-module__FpKhna__paywall-check-icon",
  "paywall-list": "paywall-module-scss-module__FpKhna__paywall-list",
  "paywall-list-button": "paywall-module-scss-module__FpKhna__paywall-list-button",
  "paywall-list-buttons": "paywall-module-scss-module__FpKhna__paywall-list-buttons",
  "paywall-list-heading": "paywall-module-scss-module__FpKhna__paywall-list-heading",
  "paywall-list-item": "paywall-module-scss-module__FpKhna__paywall-list-item",
  "paywall-list-wrapper": "paywall-module-scss-module__FpKhna__paywall-list-wrapper",
  "paywall-logo-wrapper": "paywall-module-scss-module__FpKhna__paywall-logo-wrapper",
  "paywall-register-form": "paywall-module-scss-module__FpKhna__paywall-register-form",
  "paywall-subtitle": "paywall-module-scss-module__FpKhna__paywall-subtitle",
  "paywall-title": "paywall-module-scss-module__FpKhna__paywall-title",
  "paywall-wrapper": "paywall-module-scss-module__FpKhna__paywall-wrapper",
  "regwall-wrapper": "paywall-module-scss-module__FpKhna__regwall-wrapper",
});
